module.exports = __webpack_public_path__ + "img/1-8.c2cd99d4.png";